import DashboardComponent from '@/pages/dashboard/Dashboard';

export const Dashboard = DashboardComponent;
